// extracted by mini-css-extract-plugin
module.exports = {"tab":"src-components-WorkspaceTabs-styles-module__tab--3dcBo","close":"src-components-WorkspaceTabs-styles-module__close--3GC3l"};